import React from 'react';
import translate from '../../i18n/translate';

const ZENODO_DOI = 'https://doi.org/10.5281/zenodo.20038868';
const DVBC_PDF   = './documents/DVBC_Metha_CaseStudy_v1.4.1.pdf';

const WHITEPAPERS = {
  EN: './documents/Metha_Whitepaper_2026_EN.pdf',
  ES: './documents/Metha_Whitepaper_2026_ES.pdf',
  FR: './documents/Metha_Whitepaper_2026_FR.pdf',
};

// Legal due diligence and audit-funding studies. Available as DOCX today
// (English + Spanish). PDF + French translations are queued for the
// document-format pass — see Checklist - Roadmap v2.docx Section 4.
const DUE_DILIGENCE = {
  EN: './documents/legal/Metha_Legal_DueDiligence_2026_EN.docx',
  ES: './documents/legal/Metha_Legal_DueDiligence_2026.docx',
};
const AUDIT_FUNDING = {
  EN: './documents/Auditing_Funding_Biomedical_Research.docx',
  ES: './documents/Auditoria_Financiacion_Biomedica.docx',
};

/**
 * Papers — public research and documentation set. Renders four cards:
 *   1. DVBC case study (DOI + PDF + SSRN pending)
 *   2. Whitepaper (3 locale PDFs)
 *   3. Legal due diligence (DOCX EN + ES today; PDF/FR pending)
 *   4. Audit funding study (DOCX EN + ES today; PDF/FR pending)
 *
 * Section heading and per-paper copy go through lv2-* i18n keys.
 * The "pending" anchors are rendered with a 'disabled' class + aria-disabled
 * so the layout stays consistent but the link doesn't navigate.
 */
export default function Papers() {
  return (
    <section className="lv2-section" id="papers">
      <div className="lv2-shell">
        <div className="lv2-section-head">
          <span className="lv2-section-tag">{translate('lv2-papers-tag')}</span>
          <h2>{translate('lv2-papers-h2')}</h2>
          <p className="sub">{translate('lv2-papers-sub')}</p>
        </div>

        <div className="lv2-papers-grid">
          <article className="lv2-paper-card">
            <span className="badge">DVBC · v1.4.1</span>
            <h3>{translate('lv2-papers-paper-title')}</h3>
            <span className="meta">{translate('lv2-papers-paper-meta')}</span>
            <p>{translate('lv2-papers-paper-p')}</p>
            <div className="links">
              <a href={DVBC_PDF} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-paper-cta-pdf')}</a>
              <a href={ZENODO_DOI} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-paper-cta-zenodo')}</a>
              <a className="disabled" title="SSRN listing pending validation" aria-disabled="true">{translate('lv2-papers-paper-cta-ssrn')}</a>
            </div>
          </article>

          <article className="lv2-paper-card">
            <span className="badge">Whitepaper · v6.0</span>
            <h3>{translate('lv2-papers-wp-title')}</h3>
            <span className="meta">{translate('lv2-papers-wp-meta')}</span>
            <p>{translate('lv2-papers-wp-p')}</p>
            <div className="links">
              <a href={WHITEPAPERS.EN} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-wp-cta-en')}</a>
              <a href={WHITEPAPERS.ES} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-wp-cta-es')}</a>
              <a href={WHITEPAPERS.FR} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-wp-cta-fr')}</a>
            </div>
          </article>

          <article className="lv2-paper-card">
            <span className="badge">Legal · DD 2026</span>
            <h3>{translate('lv2-papers-dd-title')}</h3>
            <span className="meta">{translate('lv2-papers-dd-meta')}</span>
            <p>{translate('lv2-papers-dd-p')}</p>
            <div className="links">
              <a href={DUE_DILIGENCE.EN} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-dd-cta-en')}</a>
              <a href={DUE_DILIGENCE.ES} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-dd-cta-es')}</a>
              <a className="disabled" title="French translation pending — see roadmap §4 document-format pass" aria-disabled="true">{translate('lv2-papers-dd-cta-fr')}</a>
            </div>
          </article>

          <article className="lv2-paper-card">
            <span className="badge">Methodology · 2026</span>
            <h3>{translate('lv2-papers-audit-title')}</h3>
            <span className="meta">{translate('lv2-papers-audit-meta')}</span>
            <p>{translate('lv2-papers-audit-p')}</p>
            <div className="links">
              <a href={AUDIT_FUNDING.EN} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-audit-cta-en')}</a>
              <a href={AUDIT_FUNDING.ES} target="_blank" rel="noopener noreferrer">{translate('lv2-papers-audit-cta-es')}</a>
              <a className="disabled" title="French translation pending — see roadmap §4 document-format pass" aria-disabled="true">{translate('lv2-papers-audit-cta-fr')}</a>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
